import React from 'react';
import { useSelector } from 'react-redux';
import { Progress } from '@prima-afp/prima-ui-elements/dist/core';
import { WrapperStyled } from './styles';

const AppLoader = ({ children }) => {

  const { showAppLoader } = useSelector(state => state.appLoader);

  return (
    <>
      {
        showAppLoader && (
          <WrapperStyled>
            <Progress />
          </WrapperStyled>
        )
      }
      {children}
    </>
  )
}

export default AppLoader;